// Should stay in sync with the enum notificationIcons.mjs

const NOTIFICATION_ICONS = {
  SUCCESS: 0,
  INFO: 1,
  WARNING: 2,
  ERROR: 3
};

export default NOTIFICATION_ICONS;
